export async function uploadToCloudinary(file) {
  const data = new FormData();
  data.append('file', file);
  data.append('upload_preset', 'shabbat_profile'); // שם ה-upload preset שלך

  const res = await fetch('https://api.cloudinary.com/v1_1/dde5vt5eq/image/upload', {
    method: 'POST',
    body: data
  });
  const json = await res.json();
  if (!json.secure_url) throw new Error('העלאת התמונה נכשלה');
  return json.secure_url;
} 